export default "/react/urbanIcon-ec054c2f.svg";